var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Modals from '../Modals';
function WebAppTrailApply(props) {
    return Modals.AppTrailApply(__assign(__assign({}, props), { isVisible: true }));
}
export default WebAppTrailApply;
//# sourceMappingURL=index.js.map